module.exports = __webpack_public_path__ + "img/image7.b6b25461.png";